import { useState } from 'react'
import { toast } from 'sonner'

import { useDownloadDocument } from '@/frontend/features/documents/use-download-document'

/** Downloads the patient's history PDF, rendered by the backend from their records. */
export function useDownloadPatientHistory(patientId: string) {
  const { downloadDocument } = useDownloadDocument()
  const [isDownloading, setIsDownloading] = useState(false)

  async function download() {
    setIsDownloading(true)
    const result = await downloadDocument({ documentType: 'patient-history', input: { patientId } })
    if (!result.success) toast.error('Failed to generate patient history')
    setIsDownloading(false)
  }

  return { download, isDownloading }
}
